import type { SessionStatus } from "@/stores/session";

/**
 * Page-scroll lock while a hosted module owns the screen (PAC-1384).
 *
 * Modules mount onto <body> (single-spa-vue's default target) as
 * `position:absolute; inset:0` against the viewport and scroll inside
 * themselves. If the PAGE can scroll as well, a wheel at a module's edge drags
 * the whole module up and exposes the shell underneath — the "bar along the
 * bottom" on packhouse.metaship.ai. `standalone.css` turns page scrolling off
 * under this class; the App Home (`/` with a home page) and every pre-auth
 * page keep normal document scrolling.
 */
export const MODULE_HOST_CLASS = "sh-module-host";

export function moduleOwnsScreen(status: SessionStatus, showAppHome: boolean): boolean {
  return status === "ready" && !showAppHome;
}

export function syncModuleHost(owns: boolean, root: HTMLElement = document.documentElement): void {
  root.classList.toggle(MODULE_HOST_CLASS, owns);
}
